import { message } from "antd"
import { useCallback, useRef } from "react"
import { createRoot } from "react-dom/client"
import { useReactToPrint } from "react-to-print";
import { FlowsheetContent } from "../services/modal"
import { PaperDirection } from "@/store/flowsheet/flowsheet.slice"
import { getParperSize } from "../utils"
import { formatSvgStr } from "@/common/svg"

export const usePrintFlowFile = () => {
  const printRef = useRef<HTMLDivElement>(null);
  const rootRef = useRef<any>(null);
  const reactToPrintFn = useReactToPrint({
    contentRef: printRef,
    onPrintError: (location, error) => {
      console.log(location, error)
    },
    onAfterPrint: () => {
      rootRef.current && document.body.removeChild(rootRef.current)
      rootRef.current = null
    }
  });
  
  return useCallback((images: Array<{image: string, name: string}>, template?: FlowsheetContent) => {
    if (!(images && images.length > 0)) {
      return message.warning(`Print content is not valid`);
    }
    let parperSize: any = {
      width: '100%',
      height: '100%',
    }
    if (template && template.template) {
      const {size, direction = PaperDirection.Landscape} = template.template
      if (size) {
        const {width, height} = getParperSize(size, direction);
        parperSize = {
          width: Math.floor(width),
          height: Math.floor(height) - 2
        }
      }
    }
    const printContainer: HTMLDivElement = document.createElement('div')
    printContainer.setAttribute('id', 'printRoot');
    document.body.appendChild(printContainer)
    rootRef.current = printContainer;
    const printRoot = createRoot(printContainer)
    printRoot.render(<div ref={printRef} className="printContent">
      {images.map((item, index) => {
        const imageStr = item.image
        if (imageStr.startsWith('data:image')) {
          return <img src={item.image} key={index} style={{width: parperSize.width, height: parperSize.height, margin: '0 auto', padding: 0}} />
        }
        return <div key={index} dangerouslySetInnerHTML={{__html: formatSvgStr(item.image)}} style={{width: parperSize.width, height: parperSize.height, margin: '0 auto', padding: 0}}></div>
      })}
    </div>)
    setTimeout(() => {
      reactToPrintFn()
    }, 300);
  }, [])
}